import { Image } from 'antd';
import moment from 'moment';
import React from 'react';

import type { DepositRegistration } from '@/types/database/depositRegistration';

import { useDepositListContext } from '../../context';
import styles from './index.module.scss';

type DepositDetailModalProps = {
  tab: number;
  viewPostal: DepositRegistration;
};

const DepositDetailModal = ({ tab, viewPostal }: DepositDetailModalProps) => {
  const { setIsShowDepositDetailModal } = useDepositListContext();

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <h5 className={styles.title}>編號</h5>
        <p className={styles.content}>{viewPostal.plateNumber}</p>
        <h5 className={styles.title}>類別</h5>
        <p className={styles.content}>
          {tab === 0 ? '寄件' : tab === 1 ? '收件' : viewPostal.type}
        </p>
        {viewPostal.itemPhoto !== null && (
          <>
            <h5 className={styles.title}>物品照片</h5>
            <Image src={viewPostal.itemPhoto} />
          </>
        )}
        <h5 className={styles.title}>寄件人</h5>
        <p className={styles.content}>
          {viewPostal.type === '寄件'
            ? viewPostal.recipient || viewPostal.household
            : viewPostal.peopleName}
        </p>
        <h5 className={styles.title}>收件人</h5>
        <p className={styles.content}>
          {viewPostal.type === '寄件'
            ? viewPostal.peopleName
            : viewPostal.recipient || viewPostal.household}
        </p>
        <h5 className={styles.title}>物品名稱</h5>
        <p className={styles.content}>{viewPostal.itemName}</p>
        {viewPostal.remarks !== '' && (
          <>
            <h5 className={styles.title}>備註</h5>
            <p className={styles.content}>{viewPostal.remarks}</p>
          </>
        )}
        {viewPostal.residentPhoto && (
          <>
            <h5 className={styles.title}>領取人照片</h5>
            <Image src={viewPostal.residentPhoto} />
          </>
        )}
      </div>
      <div className={styles.timeSectionAndCloseButtonContainer}>
        <div className={styles.section}>
          <h5 className={styles.title}>登記時間</h5>
          <p className={styles.content}>
            {moment(viewPostal.createdTime).format('YYYY/MM/DD HH:mm:ss')}
          </p>
          {viewPostal.status === '已領取' && (
            <>
              <h5 className={styles.title}>領取時間</h5>
              <p className={styles.content}>
                {moment(viewPostal.receiveTime).format('YYYY/MM/DD HH:mm:ss')}
              </p>
            </>
          )}
          {viewPostal.canvas && (
            <>
              <h5 className={styles.title}>領取人簽名</h5>
              <img className={styles.signatureImage} src={viewPostal.canvas} />
            </>
          )}
        </div>
        <div className={styles.closeDetailButton}>
          <button onClick={() => setIsShowDepositDetailModal(false)}>
            關閉
          </button>
        </div>
      </div>
    </div>
  );
};

export default DepositDetailModal;
